// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1vnLn","checkboxCol":"Table_checkboxCol__gqFme","emailCol":"Table_emailCol__Co2A4","actionCol":"Table_actionCol__2g9Te"};